import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

/** /join?ref=CODE — records the link-open event, stashes the code for
 * registration attribution, then hands off to the normal signup flow.
 * Navigation is guaranteed: click tracking is best-effort with a hard
 * fallback so a slow/failed network call can never strand the visitor. */
export default function JoinRedirect() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = (params.get("ref") || "").trim();
    let done = false;
    const go = () => {
      if (!done) {
        done = true;
        navigate("/register", { replace: true });
      }
    };
    if (!code) {
      go();
      return;
    }
    // Optimistic — the backend re-validates the code at signup, so a bogus
    // code stored here is harmless and gets ignored server-side.
    try { sessionStorage.setItem("panda_ref", code); } catch { /* private mode */ }
    api.post("/referrals/click", { code })
      .then(({ data }) => {
        if (!data?.valid) {
          try { sessionStorage.removeItem("panda_ref"); } catch { /* ignore */ }
        }
      })
      .catch(() => {})
      .finally(go);
    const fallback = setTimeout(go, 2000);
    return () => clearTimeout(fallback);
  }, [params, navigate]);

  return (
    <div data-testid="join-redirect" className="min-h-screen grid place-items-center bg-black text-zinc-500 text-sm">
      🐼 Opening your invite…
    </div>
  );
}
